import { render, staticRenderFns } from "./MailNotifyDetailInfo.vue?vue&type=template&id=55ffc6d0&"
import script from "./MailNotifyDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./MailNotifyDetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports